import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Truck } from 'lucide-react';
import { Dialog, DialogTrigger, DialogTitle, DialogDescription, DialogClose } from 'components/ui/dialog';
import { PublicDialogContent } from 'components/ui/public-dialog';
import './AccessWorkspace.css';
import './NavigationAccount.css';
import './NavigationTms.css';

export default function NavigationTms({ onOpen }) {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => setOpen(false), [pathname]);
  return <Dialog open={open} onOpenChange={next => { setOpen(next); if (next) onOpen?.(); }}>
    <DialogTrigger asChild>
      <button type="button" data-testid="nav-link-tms-signin" className="site-navigation-tms" title="TMS login" aria-label="TMS login">
        <Truck size={21} strokeWidth={1.5} aria-hidden="true" />
      </button>
    </DialogTrigger>
    <PublicDialogContent className="customer-access ca-login-dialog ca-tms-dialog">
      <div className="public-dialog-emblem" aria-hidden="true"><Truck size={26} strokeWidth={1.4} /></div>
      <DialogTitle>Open TMS</DialogTitle>
      <DialogDescription>This will open the TMS login page in a new tab. Continue?</DialogDescription>
      <div className="ca-tms-actions">
        <DialogClose asChild><button type="button">Cancel</button></DialogClose>
        <DialogClose asChild>
          <a className="ca-primary" href="https://tms.magellan.international/?login=1" target="_blank" rel="noopener noreferrer">Continue</a>
        </DialogClose>
      </div>
    </PublicDialogContent>
  </Dialog>;
}
